import { render, staticRenderFns } from "./PaymentPageSettings.vue?vue&type=template&id=235c3657&scoped=true&"
import script from "./PaymentPageSettings.vue?vue&type=script&lang=js&"
export * from "./PaymentPageSettings.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPageSettings.vue?vue&type=style&index=0&id=235c3657&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c3657",
  null
  
)

export default component.exports